import { Image } from '@careaoke/ui';

export const ImageWrapper = (props) => {
  const { height, width, src } = props
  return (
    <Image htmlHeight={height} htmlWidth={width} src={src}/>
  );
};
